import { render, staticRenderFns } from "./DemoComboboxDense.vue?vue&type=template&id=519f4d20&"
import script from "./DemoComboboxDense.vue?vue&type=script&lang=js&"
export * from "./DemoComboboxDense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
